import { Shape } from "react-konva";

// original spinner comes from css-loaders, spinners #3,
// after some AI modifications to canvas code...
// voila !
const cssWidth = 50;
const cssPadding = 8;
const animationDuration = 1000; // 1 second in milliseconds
const gapPercentage = 0.2;
const rotationSpeed = (2 * Math.PI) / animationDuration; // Radians per millisecond
const totalSize = cssWidth + cssPadding * 2; // Total diameter including padding
const center = totalSize / 2;
const lineWidth = cssPadding; // The padding becomes the line thickness
const radius = center - lineWidth / 2;
const gapAngle = 2 * Math.PI * gapPercentage;
const startAngle = gapAngle / 2; // Start after half the gap
const endAngle = 2 * Math.PI - gapAngle / 2; // End before half the gap

export function CanvasSpinner({ x = 0, y = 0 }: { x?: number; y?: number }) {
  return (
    <Shape
      x={x}
      y={y}
      fillEnabled={false}
      listening={false}
      strokeWidth={lineWidth}
      stroke={"#AFB3BF"}
      lineCap="round"
      sceneFunc={(ctx, shape) => {
        const now = performance.now(); // this will be different for every component - how can I unify?
        const delta = now % animationDuration;

        // Calculate rotation increment
        let rotation = (rotationSpeed * delta) % (2 * Math.PI); // Keep angle between 0 and 2*PI

        ctx.rotate(rotation);
        ctx.beginPath();
        ctx.arc(0, 0, radius, startAngle, endAngle, false);
        ctx.fillStrokeShape(shape);
        // Konva requests animation frame on batchDraw, so in theory
        // I can just call it, but it doesn't work!
        requestAnimationFrame(() => shape.getLayer()?.batchDraw());
      }}
    />
  );
}
